import dynamic from "next/dynamic";
import TimerVerticalTabsConfig from "./timer-vertical-tabs-config";
import TimerVerticalTabsAdvancedConfig from "./timer-vertical-tabs-advanced-config";

const TimerVerticalTabsComponent = dynamic(() => import("./timer-vertical-tabs-component"));

export default {
  TimerVerticalTabsComponent,
  TimerVerticalTabsConfig,
  TimerVerticalTabsAdvancedConfig
};
